<template>
	<div>
		<div class="view-framework">
			<userLeft></userLeft>
			<div class="view-framework-body">
				<div class="view-framework-main">
					<div class="box">
						<h2 class="box-caption">我的提现记录</h2>
						<div class="form-filter">
							<div class="form-group">
								<label class="control-label">日期筛选</label>
								<el-date-picker
									v-model="value2"
									type="daterange"
									align="center"
									unlink-panels
									range-separator="至"
									start-placeholder="起始日期"
									end-placeholder="结束日期"
									:picker-options="pickerOptions"
									:editable="false"
									size='small'
									@change='optionData'
									value-format="yyyy-MM-dd">
								</el-date-picker>
								<el-select v-model="orderType" placeholder="请选择" size='small'>
								    <el-option
								      v-for="item in options"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
								</el-select>
							</div>
							<div class="form-group">
								<button class="btn btn-primary btn-sm btn-square px30" type="submit" @click="search">搜索</button>
								<button class="btn btn-default btn-sm btn-square px30" type="submit" @click="empty">清空</button>
							</div>
						</div>
						<div class="table-responsive">
							<el-table
							  :data="tableData"
							  stripe
								border
							  style="width: 100%">
							  <el-table-column
							    prop="id"
							    label="提现单号"
							    width="100">
							  </el-table-column>
							  <el-table-column
							    prop="create_time"
							    label="提现时间"
									width='200'>
							  </el-table-column>
								<el-table-column label="提现方式" width='100'>
									<template slot-scope="scope">
										<span  class="text-orange">{{delivery_status[scope.row.pay_type]}}</span> 
									</template>
								</el-table-column>
								<el-table-column label="提现账号" width='200'>
									<template slot-scope="scope">
										<span  class="text-blue">{{scope.row.account}}</span> 
									</template>
								</el-table-column>
								<el-table-column label="提现金额" width='100'>
									<template slot-scope="scope">
										<span  class="text-orange">{{scope.row.money}}</span> 
									</template>
								</el-table-column>
								<el-table-column label="手续费" width='100'>
									<template slot-scope="scope">
										<span  class="text-orange">{{scope.row.service_price}}</span> 
									</template>
								</el-table-column>
								<el-table-column label="到帐金额" width='100'>
									<template slot-scope="scope">
										<span  class="text-orange" :class="scope.row.apply_status === 30?'text-red':scope.row.apply_status === 40?'text-success':'text-orange'">{{scope.row.real_price}}</span> 
									</template>
								</el-table-column>
								<el-table-column label="当前状态" >
									<template slot-scope="scope">
										<span  class="" :class="{'text-success':scope.row.apply_status===40,
										'text-red':scope.row.apply_status===30,
										'text-gray':scope.row.apply_status===10,
										'text-blue':scope.row.apply_status === 20
										}">{{delivery_type[scope.row.apply_status]}}</span> 
									</template>
								</el-table-column>
								<el-table-column label="说明" width='250'>
									<template slot-scope="scope">
										<span  class="text-red">{{scope.row.reject_reason}}</span> 
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="text-right">
							    <el-pagination
							      @current-change="handleCurrentChange"
							      :current-page.sync="current_page"
							      :page-size="per_page"
							      layout="prev, pager, next, jumper,total"
										:page-count='last_page'
							      :total="total">
							    </el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				pickerOptions: {
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							
							picker.$emit('pick', [new Date(), new Date()]);
						}
					}, 
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}
					]
				},
				orderType:1,
				delivery_status:{
					1:'支付宝',
					2:'银行卡',
					3:'微信',
				},
				delivery_type:{
					10:'待审核',
					20:'审核通过',
					30:'驳回',
					40:"已打款"
				},
				options: [{
					value: 1,
					label: '全部'
				}, {
					value: 2,
					label: '待审核'
				}, {
					value: 3,
					label: '处理中'
				}, {
					value: 4,
					label: '完成'
				}],
				tableData:[],
				value2:[],
				dataList:[],
				current_page:1,
				last_page:10,
				per_page:10,
				total:100,
				orderType:1,
			}
		},
		created() {
			this.getWithdrawList()
		},
		methods:{
			
			getWithdrawList(){
				let token = localStorage.getItem('token')
				this.$api.WithdrawList({
					token:token,
					type: this.orderType,
					page: this.current_page,
					seachtime:this.dataList.join(',') 
				}).then(res => {
					if(res.code === 1){
						this.current_page = res.data.current_page
						this.last_page = res.data.last_page
						this.per_page = res.data.per_page
						this.total = res.data.total
						this.tableData = res.data.data
					}
				})
			},
			optionData(){
					this.dataList[0] = Math.round(new Date(this.value2[0] + ' ' + '00:00:00')/ 1000)
					this.dataList[1] = Math.round(new Date(this.value2[1] + ' ' + '00:00:00')/ 1000)
			},
			handleCurrentChange(val) {
				this.current_page = val
				this.getWithdrawList()
			},
			search(){
				this.getWithdrawList()
			},
			empty(){
				this.value2 = []
				this.dataList = []
				this.orderType = 1
				this.current_page = 1
				this.getWithdrawList()
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/user/withdrawList.vue